<div class="calendar-year">
  <div class="calendar-year__header">
    <div class="calendar-year__header-left">
      <h4 class="calendar-year__title">{{ selectedDate() | date: 'yyyy' }}</h4>
    </div>
    <div class="calendar-year__header-right">
      <button mat-icon-button (click)="onClickPrevious()">
        <mat-icon>keyboard_arrow_left</mat-icon>
      </button>
      <button mat-icon-button (click)="onClickNext()">
        <mat-icon>keyboard_arrow_right</mat-icon>
      </button>
    </div>
  </div>
  <div class="calendar-year__wrapper">
    @for (m of months(); track m; let i = $index) {
      <ng-container
        *ngTemplateOutlet="
          item;
          context: {
            fixRate: fixesOfMonths()?.[i],
            average: averageOfMonths()?.[i],
            label: m,
            index: i,
          }
        "
      ></ng-container>
    }
  </div>
  <div class="calendar-year__legend">
    <div class="calendar-year__legend-max"></div>
    <span>Maximum</span>
    <div class="calendar-year__legend-min"></div>
    <span>Minimum</span>
  </div>
</div>

<ng-template #item let-fixRate="fixRate" let-label="label" let-index="index" let-average="average">
  <span
    class="calendar-year__item"
    [ngClass]="{ active: fixRate > 0 }"
    [matTooltip]="scheduleService()?.config?.hasFixRate ? fixRate.toString() + ' Fixes' : undefined"
    (click)="onClickItem(index, fixRate > 0)"
    [style.--p]="getPercent(average) + '%'"
    [attr.data-testid]="'calendar-year-' + label"
    >{{ label }}</span
  >
</ng-template>
